export default "__VITE_ASSET__DBZG5Ye0__"